import {
  NOTIFICATIONS_QUERY_KEY,
  NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY,
} from "@frontend-shared/constants";
import type { IMarkNotificationAsReadParams } from "@frontend-shared/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { notificationsApi } from "@/api/services";

export const useMarkAsRead = () => {
  const { t } = useTranslation("notifications");
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: IMarkNotificationAsReadParams) =>
      notificationsApi.markAsRead(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [NOTIFICATIONS_QUERY_KEY] });
      queryClient.invalidateQueries({
        queryKey: [NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY],
      });
    },
    meta: {
      fallbackMessage: t("load_error"),
    },
  });
};
